
import { mapGetters } from "vuex";
import { mdiCheck } from "@mdi/js";

export default {
  props: {
    video: {
      type: Object,
      default: () => {},
    },
    hideCheckbox: {
      type: Boolean,
      default: false,
    },

    selectedVideos: Array,
  },

  data() {
    return {
      mdiCheck,
    };
  },

  computed: {
    ...mapGetters({
      discreetMode: "getDiscreetStatus",
    }),

    checkVideoValue() {
      for (let i = 0; i < this.selectedVideos.length; i++) {
        if (this.selectedVideos[i] === this.video.videokey) {
          return true;
        }
      }
      return false;
    },
  },

  methods: {
    selectVideo(videokey) {
      this.$emit("selectVideo", videokey);
    },
  },
};
